const ORIGIN = 'https://hiretempotravellersatna.com';
export const isHindiPath = path => /^\/hi(?:\/|$)/.test(path);
export const englishPath = path => (isHindiPath(path) ? path.slice(3) : path).replace(/\/+$/, '') || '/';
export function localizedPath(path, language) {
 const base = englishPath(path);
 return language === 'hi' ? (base === '/' ? '/hi' : '/hi' + base) : base;
}
export function localizeTo(to, language) {
 if (typeof to === 'object' && to !== null) return to.pathname ? {...to, pathname: localizeTo(to.pathname, language)} : to;
 if (typeof to !== 'string' || !to.startsWith('/') || to.startsWith('//')) return to;
 const split = to.search(/[?#]/), path = split < 0 ? to : to.slice(0,split), suffix = split < 0 ? '' : to.slice(split);
 if (/^\/(?:admin|api|static|images|assets)(?:\/|$)/.test(englishPath(path)) || /\.[a-z0-9]+$/i.test(path)) return to;
 return localizedPath(path,language) + suffix;
}
export function localizedUrl(value, language) {
 if (!value || typeof value !== 'string') return value;
 if (value === ORIGIN) return ORIGIN + localizedPath('/', language);
 if (value.startsWith(ORIGIN + '/')) return ORIGIN + localizeTo(value.slice(ORIGIN.length),language);
 return localizeTo(value,language);
}
